import { render } from "./LoginPhoneNumber.vue?vue&type=template&id=481f6888"
import script from "./LoginPhoneNumber.vue?vue&type=script&lang=js"
export * from "./LoginPhoneNumber.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__